/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Project_Tag_Delete_Confirm_With_UsageInputs */



/**
* | output |
* | --- |
* | "Delete this tag? It is currently used on {count} project(s)." |
*
* @param {Project_Tag_Delete_Confirm_With_UsageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_tag_delete_confirm_with_usage = /** @type {((inputs: Project_Tag_Delete_Confirm_With_UsageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tag_Delete_Confirm_With_UsageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dieses Tag löschen? Es wird derzeit von ${i?.count} Projekt(en) verwendet.`)
	return /** @type {LocalizedString} */ (`Delete this tag? It is currently used on ${i?.count} project(s).`)
});